import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Link } from 'react-router-dom';

const QRCodeGenerator = ({ qrCodeURL }) => {
  const qrCodeCanvasRef = useRef(null);

  const openQRCodeForPrint = () => {
    const canvas = qrCodeCanvasRef.current.querySelector("canvas");
    if (!canvas) {
      alert("QRCode não foi gerado corretamente!");
      return;
    }

    const qrCodeDataURL = canvas.toDataURL("image/png");
    const qrWindow = window.open("", "_blank", "width=600,height=600");
    qrWindow.document.write(`
      <html>
        <head>
          <title>Imprimir QRCode</title>
          <style>
            body {
              text-align: center;
              margin-top: 70px;
            }
            div {
              font-family: "Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif;
              font-size: 24px;
              font-weight: 600;
              color: #666666;
            }
            #print-button {
              margin-top: 20px;
            }
            @page {
              margin: 0;
            }
            @media print {
              button, #print-button {
                display: none;
              }
            }
          </style>
          <script>
            function printQRCode() {
              document.getElementById("print-button").style.display = 'none';
              window.print();
            }
          </script>
        </head>
        <body>
          <h3><img src="/images/replay-pro-logo.svg" alt="Replay Pro Logo" height="60"/></h3>
          <img src="${qrCodeDataURL}" alt="QRCode" style="width: 300px; height: 300px;" />
          <br /><br />
          <div>Acesse aqui os seus replays!</div>
          <br /><br />
          <button id="print-button" onclick="printQRCode()">Imprimir</button>
        </body>
      </html>
    `);
    qrWindow.document.close();
  };

  return (
    <Link onClick={openQRCodeForPrint} className="mt-3">
    <div ref={qrCodeCanvasRef} className="d-flex flex-column align-items-center">
      <QRCodeCanvas value={qrCodeURL} size={512} style={{ width: 64, height: 64 }} />
      
      <div className="mt-3 text-center">
        Imprimir QRCode
      </div>
    </div>
    </Link>
  );
};

export default QRCodeGenerator;
